module.exports = __webpack_public_path__ + "static/parish_photo-603bf98f0a7af3c3c4e48e31c911ffb8.jpg";